<template>
    <section>
        <v-layout row>
            <v-flex style="width: 50%; margin: 10px;font-size: 16px;font-weight: bold;">Sections Table :</v-flex>
            <v-flex style="width: 50%; margin: 10px;font-size: 16px;font-weight: bold;">Curriculam Table :</v-flex>
        </v-layout>
        <v-layout row>
            <v-flex style="width: 50%; margin: 10px;">
                <v-data-table :headers="headers" 
                        :items="GetCourseList" 
                        hide-actions
                        disable-initial-sort
                        :loading='loading' 
                        loading-text="Loading... Please wait" 
                        item-key="Course_Title" 
                        class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text"> {{ header.text }} </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                        <td class="text-xs-center">{{ props.item.Course_Curriculam.length }}</td>
                        <td class="text-xs-center">
                            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateSectionModal(props.item,'Update')">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateSectionModal(props.item,'View')">
                                <v-icon>remove_red_eye</v-icon>
                            </v-btn>
                            <v-btn color="error" icon class="btnAction" @click="DeleteCompleteSection(props.item)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        </v-flex>
        <v-flex style="width: 50%; margin: 10px;">
            <v-data-table :headers="headers" 
                        :items="GetCourseList" 
                        item-key="Course_Title" 
                        class="elevation-1"
                        hide-actions
                        disable-initial-sort
                        :loading='loading' 
                        loading-text="Loading... Please wait">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text">
                            <v-icon small>arrow_upward</v-icon> {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                        <td class="text-xs-center">{{ props.item.Course_Curriculam.length }}</td>
                        <td class="text-xs-center">
                            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCurriculamModal(props.item,'Update')">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCurriculamModal(props.item,'View')">
                                <v-icon>remove_red_eye</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        </v-flex>
        </v-layout>
        <app-update-curriculam ref="UpdateCurriculam" :dialog="UpdateCurriculam" @close='CloseDialog'></app-update-curriculam>
        <app-update-section ref="UpdateSection" :dialog="UpdateSection" @close='CloseDialog'></app-update-section>
    </section>
</template>
<script>

import appUpdateCurriculam  from '../dialogs/UpdateCurriculam'
import appUpdateSection     from '../dialogs/UpdateSection'

export default {
    components: {

        appUpdateCurriculam,
        appUpdateSection

    },
    data(){

        return {

            headers          : [ { text: 'Course Title',value: 'Course_Title' },
                                 { text: 'No Of Sections' },
                                 { text: 'Actions' } ],
            UpdateCurriculam : false,
            UpdateSection    : false,
            loading          : false,
            pages            : 1,
            records          : 0,        
        }
    },
    computed:{
        GetCourseList(){

            return this.$store.getters.GetCourseCurriculamList
        }
    },
    methods:{
      OpenUpdateCurriculamModal(Course,Type){

          this.UpdateCurriculam = true
          this.$refs.UpdateCurriculam.GetCurriculam(Course,Type)
      },
      OpenUpdateSectionModal(Course,Type){

          this.UpdateSection  = true
          this.$refs.UpdateSection.GetSection(Course,Type)
      },
      CloseDialog(){

          this.UpdateCurriculam = false
          this.UpdateSection    = false
      },
      GetNextSetOfData(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/getcoursedetails`,{ limit:10, page : this.pages })
                        .then(response =>{
                            
                            this.$store.commit('SetCourseCurriculamList',response["data"]["response"])
                            this.records = response["data"]["Records"]
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
      },
      DeleteCompleteSection(section){
        if (confirm("Do you really want to delete?")) {
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursecurriculam/deletesection`,{ 'Section_Id' : section['_id'] })
                            .then(response =>{
                                
                                this.$store.commit('DeleteIndividualCourseCurriculam',response["data"]["response"])

                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                            })

          }
      }
      },
      mounted(){

        this.GetNextSetOfData()
      }
  }
</script>
<style>
.VuePagination ul{    
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>


